// extracted by mini-css-extract-plugin
module.exports = {"root":"EditForm_root__2uY_B","btns":"EditForm_btns__3MFef","btn":"EditForm_btn__8jP94"};